const queue = {
    add_to_cart: [],
    remove_from_cart: []
};

/**
 * Fetches the product info from the Shopify store
 * @param {string} handle the handle of the product
 * @param {string} [variant_id=""] the variant id of the product
 * @returns {Promise<Object>} a promise that resolves with the product object
 */

window.getProdInfo = function (handle, variant_id = "") {
    return new Promise((resolve, reject) => {
        fetch(`${window.Shopify.routes.root}products/${handle}?view=details&variant=${variant_id}`)
            .then(response => response.json())
            .then(product => {
                resolve(product);
            })
            .catch(error => reject(error));
    });
}


/**
 * Fetches the cart object from the Shopify store
 * @returns {Promise<Object>} a promise that resolves with the cart object
 */

window.getCart = function () {
    return new Promise((resolve, reject) => {
        fetch(`${window.Shopify.routes.root}cart.js`)
            .then(response => response.json())
            .then(cart => {
                resolve(cart)
            })
            .catch(error => reject(error));
    });
}

window.viewItemList = async function() {
    const items = await window.getProducts();

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "view_item_list",
        ecommerce: items
    });
}


/**
 * Fetches the list of products from the Shopify store
 * @returns {Promise<Array.<Object>>} a promise that resolves with the list of products
 */

window.getProducts = function () {
    const url = new URL(document.location.href);
    if (url.searchParams.get('view') !== 'details') {
        url.searchParams.set('view', 'details');
    }
    return new Promise((resolve, reject) => {
        fetch(url.toString())
            .then(response => response.json())
            .then(list => {
                resolve(list)
            })
            .catch(error => reject(error));
    });
}


window.addEventListener("add_to_cart_dl", function (ev) {
    if (ev.detail) {
        queue.add_to_cart.push(ev.detail);
        const qty = ev.detail.quantity ?? 1;

        processQueue(qty);
    }
});

window.addEventListener("remove_from_cart_dl", function (ev) {
    if (ev.detail) {
        queue.remove_from_cart.push(ev.detail);
        const qty = ev.detail.quantity ?? 1;

        processQueue(qty);
    }
});

window.addEventListener("begin_checkout_dl", async function (ev) {
    const cart = await (async () => {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        return await response.json();
    })();

    let items = [];
    for (const cart_item of cart.items) {
        const item = await window.getProdInfo(cart_item.handle, cart_item.variant_id);
        item.price = Math.round(cart_item.final_line_price / 100).toFixed(2);
        item.discount = Math.round(cart_item.line_level_total_discount /100).toFixed(2);
        item.quantity = cart_item.quantity;

        let coupon = [];
        for (const discount of cart_item.line_level_discount_allocations) {
            coupon.push(discount.discount_application.title);
        }
        item.coupon = coupon.join(", ");

        items.push(item);
    }

    let coupon = [];
    for (const discount of cart.cart_level_discount_applications) {
        coupon.push(discount.discount_application.title);
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "begin_checkout",
        coupon: coupon.join(", "),
        ecommerce: {
            currency: cart.currency,
            value: (cart.original_total_price / 100.0).toFixed(2),
            items: items
        }
    });
});

window.addEventListener("view_cart_dl", async function (ev) {
    const cart = await (async () => {        
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        return await response.json();
    })();

    let items = [];
    for (const cart_item of cart.items) {
        const item = await window.getProdInfo(cart_item.handle, cart_item.variant_id);
        item.price = Math.round(cart_item.final_line_price / 100).toFixed(2);
        item.discount = Math.round(cart_item.line_level_total_discount /100).toFixed(2);
        item.quantity = cart_item.quantity;

        let coupon = [];
        for (const discount of cart_item.line_level_discount_allocations) {
            coupon.push(discount.discount_application.title);
        }
        item.coupon = coupon.join(", ");

        items.push(item);
    }

    let coupon = [];
    for (const discount of cart.cart_level_discount_applications) {
        coupon.push(discount.discount_application.title);
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "view_cart",
        coupon: coupon.join(", "),
        ecommerce: {
            currency: cart.currency,
            value: (cart.original_total_price / 100.0).toFixed(2),
            items: items
        }
    });
});

/**
 * Process the add_to_cart and remove_from_cart queues.
 * It will add a product to the ecommerce object in the dataLayer and
 * remove it from the queue.
 * It will call itself until the queue is empty.
 */

function processQueue(qty = 1) {
    if (queue.add_to_cart.length > 0 || queue.remove_from_cart.length > 0) {
        (async () => {
            const item = queue.add_to_cart.length > 0 ? await window.getProdInfo(...Object.values(queue.add_to_cart[0])) : await window.getProdInfo(...Object.values(queue.remove_from_cart[0]));
            item.quantity = qty;
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: queue.add_to_cart.length ? "add_to_cart" : "remove_from_cart",
                ecommerce: {
                    value: (item.price * item.quantity).toFixed(2),
                    currency: Shopify.currency.active,
                    items: [
                        item
                    ]
                }
            });
            if (queue.add_to_cart.length > 0) {
                queue.add_to_cart.shift();
            }
            if (queue.remove_from_cart.length > 0) {
                queue.remove_from_cart.shift();
            }
            processQueue();
        })();
    }
}


window.addEventListener("load", async function () {
    let td_country = '';
    if (['IT', 'US', 'GB'].includes(Shopify.country)) {
        td_country = Shopify.country;
    }
    window.dataLayer.push({
        event: "TDCOUNTRY",
        td_country: td_country
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "page_view",
        page: {
            url: document.querySelector('meta[property="og:url"]').content,
            title: document.querySelector('meta[property="og:title"]').content,
            type: document.querySelector('meta[property="og:type"]').content
        }
    });

    if (document.body.classList.contains("template-collection")) {
        window.viewItemList();
    }
    else if (document.body.classList.contains("template-cart")) {
        window.dispatchEvent(new CustomEvent('view_cart_dl'));
    }

    if (document.body.dataset.productHandle) {
        const item = await window.getProdInfo(document.body.dataset.productHandle);

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                value: (item.price * item.quantity).toFixed(2),
                currency: Shopify.currency.active,
                items: [
                    item
                ]
            }
        });
    }
});


document.addEventListener("click", function (event) {
    if (event.target.tagName === "BUTTON" && event.target.hasAttribute("data-dl-cart")) {
        const btn = event.target;
        const variantId = btn.dataset.variantId;
        const product = btn.dataset.product;
        const item = btn.closest('[data-cart-actions]');

        switch (true) {
            case btn.type === "reset":
                const qty = btn.dataset.qty;
                window.dispatchEvent(new CustomEvent('remove_from_cart_dl', {
                    detail: { handle: product, variantId: variantId, quantity: qty }
                }));
                break;

            case btn.hasAttribute("data-minus"):
                window.dispatchEvent(new CustomEvent('remove_from_cart_dl', {
                    detail: { handle: item.dataset.product, variantId: item.dataset.variant, quantity: 1 }
                }));
                break;

            case btn.hasAttribute("data-plus"):
                window.dispatchEvent(new CustomEvent('add_to_cart_dl', {
                    detail: { handle: item.dataset.product, variantId: item.dataset.variant, quantity: 1 }
                }));
                break;
        }
    }
});